export { default } from "./src/pricing-table";
export type { UniformPricingTableProps } from "./src/pricing-table";
